<template>
	<HeaderTemplate />
	<div v-if="showFailedLoginModal">
		<div class="it-example-modal">
			<div class="modal alert-modal show d-block" tabindex="-1" role="dialog" id="modal3" aria-labelledby="modal3Title">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<svg class="icon"><use :href="this.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-info-circle'"></use></svg>
							<h2 class="modal-title h5 " id="modal3Title">Attenzione</h2>
						</div>
						<div class="modal-body">
							<p>Non è stato possibile effettuare l'accesso.<br>Si prega di riprovare più tardi.</p>
						</div>
						<div class="modal-footer">
							<button class="btn btn-primary btn-sm" type="button" @click="closeFailedLoginModal">Chiudi</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<main class="main">
		<component :is="currentView" :key="this.$route.fullPath" :article="this.article" :section="this.section" :version="this.version"></component>
	</main>
	<FooterTemplate />
</template>

<style>
@import "./assets/css/bootstrap-icons/bootstrap-icons.css";

.it-hero-wrapper {
	margin-top: 6.5em;
	min-height: 260px !important;
	background: linear-gradient(-180deg, rgba(0, 102, 204, 1) 0%, rgba(0, 51, 102, 1) 100%);
}

.fade-transition-enter-active,
.fade-transition-leave-active {
  transition: opacity 1s ease, transform 1s ease;
}

.fade-transition-enter-from,
.fade-transition-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fade-transition-enter-to,
.fade-transition-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Loading modal animations */
.loading-modal {
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes pulse {
  0% { opacity: 0.7; }
  50% { opacity: 1; }
  100% { opacity: 0.7; }
}

@keyframes spin {
  0% { transform: scale(0.8); }
  50% { transform: scale(1.2); }
  100% { transform: scale(0.8); }
}

.main {
	max-width:100vw;
}
.tiptap.ProseMirror a {
	color: var(--bs-link-color) !important;
}

.tiptap.ProseMirror a:hover {
	color: var(--bs-link-hover-color) !important;
}

/* Survey Button Styles */
.survey-button-container {
    margin: 0.75rem 0;
}

.survey-button-hero {
	width: 340px;
}

.survey-button {
    border: none;
    border-radius: 12px;
    padding: 16px 20px;
    color: white !important;
    font-weight: 500;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    min-height: 60px;
}

.survey-icon {
    font-size: 1.5rem;
}

.survey-text {
    text-align: left;
    flex-grow: 1;
}

.survey-title {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 2px;
}

.survey-subtitle {
    font-size: 0.875rem;
    opacity: 0.9;
    font-style: italic;
}

.survey-arrow {
    font-size: 1.25rem;
    transition: transform 0.3s ease;

}
</style>

<script>
import { getCurrentInstance } from 'vue';
import { ref } from 'vue';

import HomeView from './components/views/HomeView';
import ArticleView from './components/views/ArticleView';
import SectionView from './components/views/SectionView';
import PrivacyView from './components/views/PrivacyView';
import PoliticaView from './components/views/PoliticaView';

import HeaderTemplate from './components/template/Header.vue'
import FooterTemplate from './components/template/Footer.vue'
import { ContentTree } from './classes/tree.js'
import lodash from 'lodash'

export default {
	name: 'App',
	components: {
		HeaderTemplate,
		FooterTemplate
	},
	setup() {
		const currentView = ref(HomeView);
		const showFailedLoginModal = ref(false);
		
		let user = ref(null)
		const isAuthenticated = ref(false);
		const authUserData = ref(null);

		function loadUserInfo() {
			// Ottieni tutti i cookie
			const cookies = getCookies();
			
			// Non rimuoviamo il token per evitare conflitti con il backoffice
			// localStorage.removeItem('token');
			if (cookies.digitapp_session) {
				const token = localStorage.setItem('token', cookies.digitapp_session);
				try {
					const jwtParts = cookies.digitapp_session.split('.');
					if (jwtParts.length === 3) {
						const payloadBase64 = jwtParts[1];
						const payload = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
						if (payload) {
							isAuthenticated.value = true;
							authUserData.value = payload.data;
							user.value = payload
						}
					}
				} catch (error) {
					console.error(error)
				}
			}
		}

		function refreshUserInfo() {
			const cookies = getCookies();
			if (cookies.digitapp_session && localStorage.getItem('token')) {
				fetch(`${config.VUE_APP_BACKOFFICE_URL}/auth/refresh`, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${localStorage.getItem('token')}`
					}
				}).then(response => {
					if (response.ok) {
						return response.json().then(data => {
							if (data && data.token) { // Verifica se il token è presente nella risposta
								const token = data.token; // Usa il token direttamente dalla risposta
								localStorage.setItem('token', token); // Aggiorna il localStorage
								cookies.digitapp_session = token; // Aggiorna anche il riferimento locale ai cookie
								
								try { // Facciamo il parsing del JWT
									const jwtParts = token.split('.');
									if (jwtParts.length === 3) {
										const payloadBase64 = jwtParts[1];
										const payload = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
										if (payload) {
											isAuthenticated.value = true;
											authUserData.value = payload.data;
											user.value = payload;
										}
									}
								} catch (error) {
									console.error('Errore nel parsing JWT:', error);
								}
							}
						});
					}
				}).catch(error => {
					console.error(error)
				})
			}
		}

		function changeView(view, sectionValue, articleValue, versionValue) {
			currentView.value = view;
			this.article = articleValue;
			this.section = sectionValue;
			this.version = versionValue;
			refreshUserInfo();
		}

		const { appContext } = getCurrentInstance()
		const config = appContext.config.globalProperties.$config

		// Funzione per ottenere tutti i cookie come oggetto
		function getCookies() {
			const cookiesObj = {};
			const decodedCookies = decodeURIComponent(document.cookie);
			
			if (!decodedCookies) return cookiesObj;
			
			decodedCookies.split(';').forEach(cookie => {
				const parts = cookie.trim().split('=');
				if (parts.length === 2) {
					const name = parts[0].trim();
					const value = parts[1].trim();
					cookiesObj[name] = value;
				}
			});
			
			return cookiesObj;
		}

		loadUserInfo();
		
		return { 
			currentView, 
			changeView, 
			loadUserInfo,
			config,
			showFailedLoginModal,
			user
		};
	},
	watch: {
		'$route.fullPath'(to, from) {
			this.updateLocation()
		}
	},
	async created() {
		//load tree contents
		await this.fetchDlgs();
		await this.fetchContents();
		await this.fetchAccessMessages();
	},
	async mounted() {
		if (window.location.search.includes('login=failed')) {
			this.showFailedLoginModal = true;
		}
		this.updateLocation();
	},
	data() {
		return {
			contents: undefined, //this.getContents(),
			contentTree: undefined, //new ContentTree(lodash.cloneDeep(this.contents)),
			contentsLoading: false, // Flag to track if contents are being loaded
			articleLoading: false, // Flag to track if an article is being loaded (global state)
			currentArticleRequest: null, // Store the current article request promise
			dlgs: {},
			baseURL: this.config.VUE_APP_BASE_URI + this.config.VUE_APP_BASE_PATH,
			article: "",
			section: "",
			version: "",
			breadcrumbData: {
				section: undefined,
				article: undefined,
			},
			accessMessages: {
				request_limit_reached_message: '',
				registration_accepted_message: '',
				registration_creation_message: '',
				registration_rejected_message: ''
			}
		}
	},
	methods: {
		closeFailedLoginModal() {
			this.showFailedLoginModal = false;
			const url = new URL(window.location);
			url.searchParams.delete('login');
			window.history.replaceState({}, document.title, url.toString());
		},
		updateLocation() {
			if (this.$route.path === '/informativa-privacy') {
				this.changeView(PrivacyView, null, null, null);
				return;
			}
			if (this.$route.path === '/politica-utilizzo') {
				if (!this.$root.user) { this.$router.push('/index.html'); return; }
				this.changeView(PoliticaView, null, null, null);
				return;
			}
			let urlObj = (new URL(window.location))
			const params = new URLSearchParams(urlObj.search);
			if (!params.get('section') && !params.get('article') && !params.get('version')){
				this.changeView(HomeView, null, null, null)
			}
			if (params.get('section')) {
				this.changeView(SectionView, params.get('section'), params.get('article'), params.get('version'))
			}
			if (params.get('article')) {
				this.changeView(ArticleView, params.get('section'), params.get('article'), params.get('version'));
			}
		},
		loadBreadcrumb(node) {
			if (node === null) {
				this.breadcrumbData.section = null
				this.breadcrumbData.article = null
				return
			}
			if (node.type == "section") {
				this.breadcrumbData.section = node
				this.breadcrumbData.article = null
			} else {
				this.breadcrumbData.article = node
				this.breadcrumbData.section = null
			}
		},
		async fetchContents() {
			// Se i contenuti sono già caricati o in fase di caricamento, non fare nulla
			if (this.contentTree || this.contentsLoading) {
				return;
			}
			
			// Imposta il flag di caricamento
			this.contentsLoading = true;
			
			try {
				console.log('Fetching contents...');
				const response = await fetch(this.config.VUE_APP_BACKOFFICE_URL + '/contents')
				if (response.ok) {
					const data = await response.json()
					this.contents = data.data
					if (data.status) {
						this.contentTree = new ContentTree(lodash.cloneDeep(this.contents))
						console.log('Contents loaded successfully');
					}
				}
			} catch (error) {
				console.error('Error loading contents:', error);
				//TODO: aggiungi un avviso di errore
			} finally {
				// Reimposta il flag di caricamento
				this.contentsLoading = false;
			}
		},
		async fetchAccessMessages() {
			const response = await fetch(this.config.VUE_APP_BACKOFFICE_URL + "/use-requests/access-messages")
			if (response.ok) {
				const data = await response.json()
				this.accessMessages = data
			}
		},
		async fetchDlgs() {
			const response = await fetch(this.config.VUE_APP_BACKOFFICE_URL + "/versions")
			if (response.ok) {
				const data = await response.json()
				this.dlgs = {};
				if (data.status) {
					data.data.versions.forEach(dlg => {
						this.dlgs[dlg.id] = dlg;
					});
				}
			}
			//TODO: aggiungi un avviso di errore
		},
		updateContentTree() { //notifica Vue dell'aggiornamento dei nodi del contentTree
			this.contentTree.nodes = [...this.contentTree.nodes];
		},
		// Metodo per caricare un articolo una sola volta, anche se richiesto da più componenti
		async fetchArticle(articleId, versionId = '', validityDate = null) {
			// Se c'è già una richiesta in corso per lo stesso articolo, restituisci quella
			if (this.articleLoading && this.currentArticleRequest) {
				return this.currentArticleRequest;
			}
			
			this.articleLoading = true;
			
			// Costruisci l'URL
			let url = `${this.config.VUE_APP_BACKOFFICE_URL}/article/${articleId}/${versionId}`;
			if (validityDate) {
				url += `?validity_date=${validityDate}`;
			}
			
			// Crea e memorizza la promise
			this.currentArticleRequest = fetch(url)
				.then(response => {
					if (response.ok) {
						return response.json();
					}
					throw new Error('Failed to fetch article');
				})
				.catch(error => {
					console.error('Error fetching article:', error);
					throw error;
				})
				.finally(() => {
					this.articleLoading = false;
				});
			
			return this.currentArticleRequest;
		},
	}
}
</script>